import { apiAgent } from "../../../axiosConfig"
import getApiUrl from "../../utils/UrlHelper"

export const fetchSmartAggregates = (data_params) => {
    return apiAgent({
        method: "get",
        url: "/aggregates/smart_articles",
        params: data_params
    })
}
export const fetchAggregates = (data_params, type) => {
    let aggregate_url = "get_feed_aggregates"
    if(type === 'high')
        aggregate_url = "get_feed_aggregates"
    if(type === 'mid' || type === 'low')
        aggregate_url = 'get_article_aggregates'
    if(type === 'prospects')
        aggregate_url = "get_prospect_aggregates"
    if(type === 'directory')
        aggregate_url = "get_directory_aggregates"
    return apiAgent({
        method: "get",
        url: getApiUrl(aggregate_url),
        params: data_params
    })
}